import React from "react";
import "./Footer.css";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaChevronRight
} from "react-icons/fa";

import { useLanguage } from "../../context/LanguageContext";

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="footer">
      <div className="footer-container">

        {/* BRAND */}
        <div className="footer-brand">
          <h2 className="footerbrandheader">
            {t.footer.brandTitle}
          </h2>
          <p>
            {t.footer.brandDescription}
          </p>
        </div>

        {/* LINKS */}
        <div className="footer-links">
          <h4>{t.footer.navigationTitle}</h4>
          <a href="#about">
            <FaChevronRight /> {t.footer.links.about}
          </a>
          <a href="#services">
            <FaChevronRight /> {t.footer.links.services}
          </a>
          <a href="#gallery">
            <FaChevronRight /> {t.footer.links.gallery}
          </a>
          <a href="#contact">
            <FaChevronRight /> {t.footer.links.contact}
          </a>
        </div>

        {/* CONTACT */}
        <div className="footer-contact">
          <h4>{t.footer.contactTitle}</h4>
          <p>
            <FaPhoneAlt /> 0658737849
          </p>
          <p>
            <FaEnvelope /> moniechafaudage@outlook.fr
          </p>
          <p>
            <FaMapMarkerAlt /> {t.footer.addressValue}
          </p>
        </div>

      </div>

      {/* BOTTOM */}
      <div className="footer-bottom">
        © {new Date().getFullYear()} {t.footer.brandTitle} — {t.footer.copyright}
      </div>
    </footer>
  );
};

export default Footer;
